import {recipeToJournalDraft} from './recipe-process.js';

function required(value,label,max=160){
  const text=String(value??'').trim();
  if(!text)throw new TypeError(label+' is required');
  if(text.length>max)throw new TypeError(label+' is too long');
  return text;
}

function proposedSmoker(smoker){
  if(smoker==null)return null;
  const id=required(smoker.id,'defaultSmoker.id',128);
  const name=String(smoker.name??'').trim()||null;
  return Object.freeze({
    smokerId:id,
    name,
    proposedOnly:true
  });
}

export function recipeUseRequestKey(userId,useRequestId){
  return required(userId,'userId',128)+':'+required(useRequestId,'useRequestId',128);
}

function hash32(value,seed){
  let hash=seed>>>0;
  const input=String(value);
  for(let index=0;index<input.length;index++){
    hash^=input.charCodeAt(index);
    hash=Math.imul(hash,16777619);
    hash^=hash>>>13;
  }
  return hash>>>0;
}

export function recipeUseDeterministicUuid(kind,sourceId,useRequestId){
  const input=[
    required(kind,'kind',64),
    required(sourceId,'sourceId',160),
    required(useRequestId,'useRequestId',128)
  ].join('|');
  const words=[
    hash32(input,0x811c9dc5),
    hash32(input,0x9e3779b9),
    hash32(input,0x85ebca6b),
    hash32(input,0xc2b2ae35)
  ];
  const hex=words.map(word=>word.toString(16).padStart(8,'0')).join('').split('');
  hex[12]='5';
  hex[16]=((parseInt(hex[16],16)&0x3)|0x8).toString(16);
  const value=hex.join('');
  return value.slice(0,8)+'-'+value.slice(8,12)+'-'+value.slice(12,16)+'-'+value.slice(16,20)+'-'+value.slice(20);
}

export function createRecipeUseDraft({
  plan,
  userId,
  useRequestId,
  idFactory=recipeUseDeterministicUuid,
  defaultSmoker=null,
  resolveCustomProductId=null,
  locale=null
}={}){
  const owner=required(userId,'userId',128);
  const requestId=required(useRequestId,'useRequestId',128);
  if(typeof idFactory!=='function')throw new TypeError('idFactory is required');

  const requestScopedIdFactory=(kind,sourceId)=>{
    const id=String(idFactory(kind,sourceId,requestId)||'').trim();
    if(!id)throw new TypeError('idFactory must return an id');
    return id;
  };

  const draft=recipeToJournalDraft(plan,{
    userId:owner,
    idFactory:requestScopedIdFactory,
    resolveCustomProductId,
    locale,
    useRequestId:requestId
  });

  return Object.freeze({
    ...draft,
    useRequestId:requestId,
    requestKey:recipeUseRequestKey(owner,requestId),
    proposedSmoker:proposedSmoker(defaultSmoker),
    offlineReady:true
  });
}
